import { useEffect } from 'react';
import { useScript } from './use-script';

export const useHumanScript = (pageRef) => {
  const humanScriptSrc = window.SS_GLOBALS?.frontEndConfig?.humanScriptSrc;
  useScript(humanScriptSrc || '', pageRef);
  useEffect(() => {
    window.hs_pagetype = 'checkout';

    return () => {
      delete window.hs_pagetype;
    };
  }, []);
};
